<footer>
    <div class="footer">
<!--        <span id="copyright">-->
<!--            Copyright &#169; <span>Brodie Hamilton</span> 2020-2021-->
<!--        </span>-->
    </div>
</footer>

<style>
    footer {
        position: relative;
        text-align: center;
        /*margin-top: 40px;*/
    }
    #copyright {
        opacity: 0.4;
        transition: all 1s ease;
        font-family: Helvetica, Arial, sans-serif;
        font-weight: lighter;
    }
    #copyright:hover {
        opacity: 0.8;
    }
    #copyright > span {
        text-transform: uppercase;
        font-family: 'Reem Kufi', sans-serif;
        letter-spacing: -1.4px;
        word-spacing: 2px;
    }
    .footer::after {
        content: "";
        display: block;
        /*border-bottom: 125px solid transparent;*/
        /*background-image: url(/footer.svg);*/
        /*background-repeat: space;*/
        /*background-size: 14px;*/
        /*mask-image: url(/images/footer.svg);*/
        /*mask-repeat: space;*/
        /*mask-size: 14px;*/
        /*background-color: #d12468;*/
        /*margin: 20px 2px 40px;*/
        box-sizing: border-box;
    }
</style>